import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetSurveysBySociogramId = sociogramId => {
  return useApiQuery(
    ['sociogram', 'surveysBySociogramId', sociogramId],
    'sociogram',
    `/surveys?sociogram_id=${sociogramId}`,
    { enabled: !!sociogramId }
  )
}
